<template>
  <v-tooltip v-if="invoiceId !== ''" top>
    <template #activator="{ on, attrs }">
      <a v-bind="attrs" v-on="on" @click.prevent="download">
        <v-icon
          :class="{ 'blinking-icon': loadingFile }"
          :color="iconColor"
          size="22"
          >mdi-file-download</v-icon
        >
      </a>
    </template>
    <span>{{ tooltipText }}</span>
  </v-tooltip>
</template>

<script>
  import axios from '@/plugins/axios';
  export default {
    props: {
      invoiceId: {
        type: String,
        required: true,
      },
      /**
       * Document type:
       * 1 - PDF Invoice
       * 2 - XML Invoice
       * 3 - Receipt Invoice Image (ACUSEDOC)
       * 4 - Receipt Invoice Image (ACUSEDOC64)
       * 5 - Receipt Invoice Image (ACUSEFAC64)
       */
      type: {
        type: Number,
        required: true,
      },
    },
    data() {
      return {
        loadingFile: false,
      };
    },
    computed: {
      tooltipText() {
        switch (this.type) {
          case 1:
            return 'Descargar PDF';
          case 2:
            return 'Descargar XML';
          default:
            return 'Descargar Acuse';
        }
      },
      iconColor() {
        switch (this.type) {
          case 1:
            return 'red';
          case 2:
            return 'blue';
          default:
            return 'green';
        }
      },
    },
    methods: {
      async download() {
        this.loadingFile = true;
        try {
          if ([1, 2].includes(this.type)) {
            await this.getPDFXMLInvoice();
          } else {
            await this.getReceiptInvoice();
          }
        } catch (error) {
          this.$toast.error('Ocurrió un error al abrir el documento');
        } finally {
          this.loadingFile = false;
        }
      },
      async getPDFXMLInvoice() {
        const response = await axios.post('/InvoicePDFXML', {
          invoice: this.invoiceId,
          type: this.type,
        });

        this.openDocument(response.data);
      },
      async getReceiptInvoice() {
        const { data } = await axios.post('/getDocumentReceipt', {
          invoice: this.invoiceId,
        });

        const imageMap = {
          3: data?.ACUSEDOC,
          4: data?.ACUSEDOC64,
          5: data?.ACUSEFAC64,
        };

        const image = imageMap[this.type] || '';
        this.openImageBase64(image);
      },
      openDocument(document) {
        document
          ? window.open(document, '_blank')
          : this.$toast.warning(
              'No se encontró ningún documento disponible para esta factura.'
            );
      },
      openImageBase64(base64Image) {
        if (!base64Image) {
          this.$toast.warning(
            'No se encontró ningún documento disponible para esta factura.'
          );
          return;
        }

        const newWindow = window.open();
        if (
          !newWindow ||
          newWindow.closed ||
          typeof newWindow.closed === 'undefined'
        ) {
          this.$toast.warning(
            'El navegador bloqueó la ventana emergente. Habilítala para ver la imagen.'
          );
          return;
        }

        const image = new Image();
        image.src = base64Image;
        image.onload = () => {
          newWindow.document.body.appendChild(image);
        };
      },
    },
  };
</script>

<style scoped>
  .blinking-icon {
    animation: blinking 1s infinite;
  }

  @keyframes blinking {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
</style>
